"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRiotGlyphs = formatRiotGlyphs;
const RIOT_CDN_BASE_URL = 'https://assetcdn.rgpub.io/public/live/riot-shared/player-experiences/riot-glyphs/';
const iconPacks = [
    {
        prefix: '2xko_',
        cdnSuffix: '2xko',
        version: 'latest',
        icons: {
            H: 'H.svg',
            L: 'L.svg',
            M: 'M.svg',
            R3: 'R3.svg',
            S1: 'S1.svg',
            S2: 'S2.svg',
            T: 'T.svg',
            back: 'back.svg',
            back_back: 'back_back.svg',
            down: 'down.svg',
            down_back: 'down_back.svg',
            down_down: 'down_down.svg',
            down_forward: 'down_forward.svg',
            forward: 'forward.svg',
            forward_forward: 'forward_forward.svg',
            or: 'or.svg',
            plus: 'plus.svg',
            round_bracket_close: 'round_bracket_close.svg',
            round_bracket_open: 'round_bracket_open.svg',
            square_bracket_close: 'square_bracket_close.svg',
            square_bracket_open: 'square_bracket_open.svg',
            sub_line: 'sub_line.svg',
            up: 'up.svg',
            up_back: 'up_back.svg',
            up_forward: 'up_forward.svg',
            up_up: 'up_up.svg',
        },
    },
];
function getImageUrl({ cdnSuffix, image, version, }) {
    let base = RIOT_CDN_BASE_URL;
    if (!base.endsWith('/')) {
        base += '/';
    }
    // If suffix is provided and not already in the path, add it
    if (cdnSuffix && !base.endsWith(`${cdnSuffix}/`)) {
        base += `${cdnSuffix}/`;
    }
    // If version is provided, append it to the base URL
    if (version && !base.endsWith(`${version}/`)) {
        base += `${version}/`;
    }
    return base + image.replace(/^\/+/, '');
}
function formatRiotGlyphs(inputString, options) {
    const { formatter } = options || {};
    const glyphRegex = /:([a-zA-Z0-9-_.]+):/g;
    return inputString.replace(glyphRegex, (matchedString, glyphName) => {
        var _a;
        for (const pack of iconPacks) {
            if (glyphName.startsWith(pack.prefix)) {
                const iconKey = glyphName.slice(pack.prefix.length);
                const image = pack.icons[iconKey];
                if (!image)
                    return matchedString;
                const imageUrl = getImageUrl({
                    cdnSuffix: pack.cdnSuffix,
                    image,
                    version: pack.version,
                });
                return ((_a = formatter === null || formatter === void 0 ? void 0 : formatter({ matchedString, imageUrl })) !== null && _a !== void 0 ? _a : `<img src="${imageUrl}" />`);
            }
        }
        return matchedString;
    });
}
